import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material";

export const CIRCLE_WIDTH = 80;
export const CIRCLE_PADDING = 3;

export const useKeySliderStyles = makeStyles(({ palette, shape }: Theme) => ({
  outerContainer: {
    float: "left",
    width: "100%",
    height: "48px",
    position: "relative",
    userSelect: "none",
    boxShadow: "0px 6px 15px rgba(65, 60, 54, 0.15)",
    borderRadius: Number(shape.borderRadius) * 25
  },
  container: {
    float: "left",
    width: "100%",
    height: "100%",
    background: "#000000",
    borderRadius: Number(shape.borderRadius) * 25,
    position: "relative",
    overflow: "hidden",
    transition: "background-color 0.2s"
  },
  containerUnlocked: {
    transition: "0.5s",
    cursor: "default",

    "& $slider": {
      // backgroundColor: staykoookTheme.palette.success.main,
    },

    "& $sliderArrow": {
      transition: "0.3s",
      marginRight: "3px"
    },

    "& $sliderCircle": {
      transition: "0.5s",
      marginRight: "3px"
    }
  },
  containerUnlockedSuccess: {
    backgroundColor: palette.success.main,

    "& $slider": {
      backgroundColor: palette.success.main
    },

    "& $sliderText": {
      color: "#000"
    }
  },
  containerUnlockedError: {
    backgroundColor: palette.error.main,

    "& $slider": {
      backgroundColor: palette.error.main
    },

    "& $sliderText": {
      color: "#FFF"
    }
  },
  slider: {
    float: "left",
    width: "100%",
    position: "absolute",
    height: "48px",
    top: 0,
    left: "83px",
    marginLeft: "-100%",
    background: "#333",
    borderRadius: Number(shape.borderRadius) * 3,
    zIndex: 100,
    cursor: "pointer",
    transition: "background-color 0.2s"
  },
  sliderText: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    lineHeight: "48px",
    textAlign: "center",
    letterSpacing: "2px",
    color: "#333",
    fontSize: "20px",
    transition: "color 0.2s"
  },
  sliderArrow: {
    float: "left",
    position: "absolute",
    top: "50%",
    right: "16px",
    marginTop: "-12px",
    zIndex: 10
  },
  sliderCircle: {
    position: "absolute",
    right: 0,
    background: "#fff",
    top: `${CIRCLE_PADDING}px`,
    height: "42px",
    width: `${CIRCLE_WIDTH}px`,
    borderRadius: Number(shape.borderRadius) * 25
  },
  text: {
    float: "left",
    position: "absolute",
    fontSize: "20px",
    top: 0,
    left: 0,
    right: 0,
    height: "48px",
    lineHeight: "48px",
    textAlign: "center",
    letterSpacing: "2px",
    color: palette.common.white
  }
}));
